// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2c80F","upload":"Small_upload__3puFI","imageWrap":"Small_imageWrap__3U4gC","removeBtn":"Small_removeBtn__1yBUN"};